module.exports = __webpack_public_path__ + "img/send-icon.d7d5426c.svg";